import { gql } from "@apollo/client";

const SAVE_TRATAMIENTO_VISITA_CD = gql`
mutation SaveTratamientoVisitaCD($input: TratamientoCDInput!) {
  saveTratamientoVisitaCD(input: $input) {
    idVisitaCD
  }
}`;

export const adaptTratamientoCDInput = (data) => ({
  idVisita: data?.idVisita,
  tratamiento: data?.obsTratamiento
});

export default SAVE_TRATAMIENTO_VISITA_CD;